// 배포 뒤 이미 열려 있던 탭이 옛 index.html/CSS 와 새 JS 청크를 섞어 쓰면 스타일이 어긋난다(버튼·로고가 커 보임).
// 서버의 index.html 이 가리키는 main 번들 해시가 지금 실행 중인 것과 달라지면 한 번만 새로고침한다.
// 청크 로드 실패(ChunkLoadError: 옛 해시의 파일이 S3 에 없음)도 같은 원인이라 같은 처리를 한다.
const MAIN_PATTERN = /main\.([a-f0-9]{8,})\.js/;
const RELOAD_FLAG = "caripay:stale-bundle-reloaded";
const CHECK_INTERVAL_MS = 60_000;

function runningMainHash(): string | null {
  const scripts = Array.from(document.scripts);
  for (const s of scripts) {
    const m = s.src.match(MAIN_PATTERN);
    if (m) return m[1];
  }
  return null;
}

function reloadOnce(reason: string): void {
  try {
    if (sessionStorage.getItem(RELOAD_FLAG) === reason) return;
    sessionStorage.setItem(RELOAD_FLAG, reason);
  } catch {
    // sessionStorage 를 못 쓰면 그대로 진행
  }
  window.location.reload();
}

async function serverMainHash(): Promise<string | null> {
  try {
    const res = await fetch("/index.html", { cache: "no-store", credentials: "same-origin" });
    if (!res.ok) return null;
    const m = (await res.text()).match(MAIN_PATTERN);
    return m ? m[1] : null;
  } catch {
    return null;
  }
}

export function installStaleBundleGuard(): void {
  if (process.env.NODE_ENV !== "production") return;
  const current = runningMainHash();
  if (!current) return;

  let checking = false;
  const check = async () => {
    if (checking || document.visibilityState !== "visible") return;
    checking = true;
    const latest = await serverMainHash();
    checking = false;
    if (latest && latest !== current) reloadOnce(latest);
  };

  window.setInterval(check, CHECK_INTERVAL_MS);
  document.addEventListener("visibilitychange", check);

  window.addEventListener("error", (e) => {
    const name = (e.error && e.error.name) || "";
    if (name === "ChunkLoadError") reloadOnce("chunk");
  });
  window.addEventListener("unhandledrejection", (e) => {
    const name = (e.reason && e.reason.name) || "";
    if (name === "ChunkLoadError") reloadOnce("chunk");
  });
}
